<!-- eslint-disable vue/no-v-html -->

<template>
  <ul class="list-menu">
    <li v-for="(item, index) in items" :key="index" class="list-menu__item">
      <component
        :is="tagName(item.routing)"
        :rel="relValue(item.routing)"
        :target="targetValue(item.routing)"
        :to="toValue(item.routing, item.link)"
        :href="hrefValue(item.routing, item.link)"
        class="list-menu__link"
        @click="emitClick"
      >
        <span class="list-menu__item-text">
          <span
            v-if="item.icon"
            class="list-menu__item-icon"
            v-html="item.icon.img"
          ></span>
          <span>{{ item.text }}</span>
          <div v-if="item.isPdf" class="list-menu__pdf-tag">PDF</div>
        </span>
        <span class="list-menu__item-arrow">
          <svg
            v-if="item.isPdf"
            width="2.4rem"
            height="2.4rem"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 12.9001L21 16C21 18.7614 18.7614 21 16 21L8 21C5.23858 21 3 18.7614 3 16L3 8C3 5.23858 5.23857 3 8 3L11.1 3"
              stroke="#222222"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M21 3L10 14"
              stroke="#222222"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M16 2H21C21.5523 2 22 2.44772 22 3V8"
              stroke="#222222"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
          <icon-arrow v-else />
        </span>
      </component>
    </li>
  </ul>
</template>

<script setup>
import IconArrow from '@/components/IconArrow'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['item-click'])

const tagName = computed(() => {
  return function (routing) {
    if (routing) return resolveComponent('NuxtLink')
    return 'a'
  }
})

const targetValue = computed(() => {
  return routing => (routing ? null : '_blank')
})

const toValue = computed(() => {
  return (routing, link) => (routing ? link : null)
})

const hrefValue = computed(() => {
  return (routing, link) => (routing ? null : link)
})

const relValue = computed(() => {
  return routing => (routing ? null : 'noopener')
})

const emitClick = () => {
  emit('item-click')
}
</script>

<style lang="scss" scoped>
.list-menu {
  .list-menu__item {
    display: flex;
    background-color: $color-white;
    border-top: 0.05rem solid $color-line;

    &:last-child {
      border-bottom: 0.05rem solid $color-line;
    }
  }

  .list-menu__link {
    display: inline-flex;
    align-items: center;
    width: 100%;
    padding: 1.6rem;
    color: $color-main-text;
    cursor: pointer;
  }

  .list-menu__item-text {
    flex: 1;
    font-size: 1.6rem;
    line-height: calc(23 / 16);
    display: flex;
    align-items: stretch;
  }

  .list-menu__item-icon {
    display: block;
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 0.4rem;
  }

  .list-menu__pdf-tag {
    display: flex;
    align-items: center;
    color: #757575;
    background-color: #e0e0e0;
    font-size: 1.2rem;
    padding: 0 0.6rem;
    font-weight: 500;
    border-radius: 0.4rem;
    margin-left: 0.8rem;
    line-height: 1;
  }

  .list-menu__item-arrow {
    margin-left: 1rem;
    width: 2.4rem;
    height: 2.4rem;
  }
}
</style>
